export default "__VITE_ASSET__BkMFdmbN__"